import React, { useState, useEffect, useRef } from 'react';
import {
  Cells,
  LoadMore,
  Cell,
  CellHeader,
  CellBody,
  CellFooter, Toast,
} from 'react-weui';
import { queryRankList } from '@/services/myself';
import firstPng from '@/assets/first.png';
import secondPng from '@/assets/second.png';
import thirdPng from '@/assets/third.png';
import { getLoginUser } from '@/utils/login';
import rankingBac from '@/assets/ranking_bac.jpg';
import rankingListBac from '@/assets/ranking_list_bac.jpg';
import userAvatar from '@/assets/user.svg';

const convertName = (tmpName) => {
  if (tmpName) {
    return tmpName[0] + " * " + tmpName.slice(2);
  } else {
    return tmpName;
  }
}


const RenderRankSort = (props) => {
  const { index } = props;
  return (
    <>
      {
        index === 1 ? <img src={firstPng} alt="" style={{ display: `block`, width: `30px`, marginRight: `5px` }} /> : null
      }
      {
        index === 2 ? <img src={secondPng} alt="" style={{display: `block`, width: `30px`, marginRight: `5px`}}/> : null
      }
      {
        index === 3 ? <img src={thirdPng} alt="" style={{display: `block`, width: `30px`, marginRight: `5px`}}/> : null
      }
      {
        index === -1 || index === 0 || index > 3 || index === "100+" ? (
          <span style={{display: `block`, fontSize: '13px', color: '#999999', textAlign: 'right', width: `30px`, marginRight: `5px`}}>
            {index}
          </span>
        ) : null
      }
    </>
  )
}


export default (props) => {

  const [isRequest, setIsRequest] = useState(false);
  const [currentList, setCurrentList] = useState([]);
  const [currentRank, setCurrentRank] = useState({
    pointsBonus: 0, rankingSort: 0, name: (getLoginUser() || {}).nickname, avatar: (getLoginUser() || {}).avatarurl
  });

  // 新增：动态获取背景图片高度
  const [bgHeight, setBgHeight] = useState(0);
  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current) {
      setBgHeight(imgRef.current.offsetHeight);
    }
  }, []);

  const handleImgLoad = () => {
    if (imgRef.current) {
      setBgHeight(imgRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    setIsRequest(true);
    queryRankList({}).then(res => {
      if (res && res.code === 200) {
        if (res.data) {
          setCurrentRank({
            pointsBonus: res.data.pointsBonus,
            rankingSort: res.data.rankingSort,
            name: (getLoginUser() || {}).nickname,
            avatar: (getLoginUser() || {}).avatarurl,
          })
          if (Array.isArray(res.data.rankingList)) {
            setCurrentList(res.data.rankingList);
          }
        }
      }
    }).finally(() => setIsRequest(false));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#c40000' }}>
      {/* 顶部舞台背景图片 */}
      <div style={{
        width: '100%',
        height: bgHeight ? `${bgHeight}px` : 'auto',
        backgroundImage: `url(${rankingBac})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        zIndex: 1
      }}>
        {/* 隐藏的图片用于获取真实高度 */}
        <img
          ref={imgRef}
          src={rankingBac}
          alt=""
          style={{ width: '100%', visibility: 'hidden', position: 'absolute', top: 0, left: 0 }}
          onLoad={handleImgLoad}
        />
      </div>
      {/* 排行榜内容区 */}
      <div style={{
        margin: '0 5%',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        padding: '20px 0',
        position: 'relative',
        zIndex: 2,
        marginTop: '0'
      }}>
        <div style={{padding: '0px 15px', fontSize: '15px', color: '#999999', marginTop: '20px', display: 'flex'}}>
          <div style={{width: '50%'}}>排名</div>
          <div style={{width: '50%', textAlign: 'right'}}>积分</div>
        </div>
        <Cells style={{marginTop: '2px'}}>
          <Cell>
            <CellHeader>
              <RenderRankSort index={currentRank.rankingSort} />
            </CellHeader>
            <CellBody>
              {
                <img style={{ borderRadius: '50%', width: '30px', height: '30px'}} src={currentRank.avatar ?  currentRank.avatar : userAvatar} />
              }
              &nbsp;&nbsp;{currentRank.name}
            </CellBody>
            <CellFooter>
              <span style={{color: '#000000'}}>
              {currentRank.pointsBonus}
              </span>
            </CellFooter>
          </Cell>
        </Cells>
        <Cells>
          {
            currentList.map((item, index) => (
              <Cell key={index}>
                <CellHeader>
                  <RenderRankSort index={index + 1} />
                </CellHeader>
                <CellBody>
                  {
                    <img style={{ borderRadius: '50%', width: '30px', height: '30px'}} src={item.avatar ?  item.avatar : userAvatar} />
                  }
                  &nbsp;&nbsp;{item.nickName ? item.nickName : convertName(item.name)}&nbsp;&nbsp;
                  {
                    item.mobile && !item.nickName ? <span style={{color: '#cccccc', fontSize: '13px',}}>
                      ({item.mobile})
                    </span> : null
                  }
                </CellBody>
                <CellFooter>
                  <span style={{color: '#000000'}}>
                  {item.points_bonus}
                  </span>
                </CellFooter>
              </Cell>
            ))
          }
        </Cells>
        <LoadMore showLine>
          { currentList.length >= 100 ? '排行榜仅显示前100名' : '排名结束'}
        </LoadMore>
      </div>
      <Toast icon="loading" show={isRequest}>加载中...</Toast>
    </div>
  );
}


